import { UiStrategy } from "@/ui/UiStrategy";
import { ClassicShell } from "@/ui/v1/ClassicShell";
import { ModernShell } from "@/ui/v2/ModernShell";
import { NeonShell } from "@/ui/v3/NeonShell";

export default function AppShell() {
  return (
    <UiStrategy
      classic={<ClassicShell />}
      modern={<ModernShell />}
      neon={<NeonShell />}
    />
  );
}
